exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-list-designer-layouter{display:flex;align-items:baseline}.fts-list-designer-layouter.list-designer-layouter-wrap{flex-wrap:wrap}.fts-list-designer-layouter:not(.list-designer-layouter-wrap){max-width:100%}.fts-list-designer-layouter:not(.list-designer-layouter-wrap) .list-designer-element-name{white-space:nowrap}.fts-list-designer-layouter .list-designer-column{margin:.375rem 0}", ""]);

// exports
